import { RadioGroup } from '@headlessui/react'
import { ForwardedRef, forwardRef, ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export interface OptionProps {
  className?: string | undefined
  children: ReactNode
  value: unknown
  disabled?: boolean | undefined
}
export const Option = forwardRef(
  function Option ({ className, disabled = false, ...passthroughProps }: OptionProps, ref: ForwardedRef<HTMLDivElement>) {
    return (
      <RadioGroup.Option
        {...passthroughProps}
        disabled={disabled}
        ref={ref}
        className={({ checked }) => twMerge(
          'core-segment-option',
          'typo-body row-[segments] flex h-8 flex-1 cursor-pointer select-none items-center justify-center rounded border-2 px-1 text-black',
          'whitespace-nowrap hover:border-black focus:border-black',
          checked ? 'border-white bg-white' : 'border-gray-200 bg-gray-200',
          disabled ? 'cursor-not-allowed opacity-50 hover:border-transparent focus:border-transparent' : '',
          className
        )}
      />
    )
  }
)

export interface SegmentProps<T> {
  className?: string | undefined
  children: ReactNode
  description?: ReactNode
  label?: ReactNode
  value: T
  onChange: (value: T) => void
}
export const Root = forwardRef(
  function Segment <T = string> ({ className, children, description, label, ...passthroughProps }: SegmentProps<T>, ref: ForwardedRef<HTMLDivElement>) {
    return (
      <RadioGroup
        {...passthroughProps}
        ref={ref}
        className={twMerge(
          'core-segment',
          'typo-body flex flex-col space-y-1',
          className
        )}
      >

        {Boolean(label) && (
          <RadioGroup.Label
            className={twMerge(
              'core-segment-label',
              'typo-body-medium text-gray-600'
            )}
          >
            {label}
          </RadioGroup.Label>
        )}

        <div className='flex gap-1 rounded border-2 border-gray-200 bg-gray-200'>
          {children}
        </div>

        {Boolean(description) && (
          <div className='typo-caption font-medium text-gray-600'>
            {description}
          </div>
        )}

      </RadioGroup>
    )
  }
)
